"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ContentCurationList = _interopRequireDefault(require("../ContentCurationList"));

var _ForumContentCurationItem = _interopRequireDefault(require("./ForumContentCurationItem"));

var _Article = _interopRequireDefault(require("@insided/destination/icons/Article"));

var _Question = _interopRequireDefault(require("@insided/destination/icons/Question"));

var _Answer = _interopRequireDefault(require("@insided/shared/icons/Answer"));

var _Discussion = _interopRequireDefault(require("@insided/destination/icons/Discussion"));

var _Idea = _interopRequireDefault(require("@insided/destination/icons/Idea"));

var _ProductUpdate = _interopRequireDefault(require("@insided/destination/icons/ProductUpdate"));

var _LoadingSpinner = require("@insided/deprecated-control/ui-components/LoadingSpinner");

var _classnames = _interopRequireDefault(require("classnames"));

var _TopicListHeader = _interopRequireDefault(require("@insided/deprecated-preact-components/content-curation/forum/TopicListHeader"));

var _categoryService = require("@insided/destination/modules/Categories/categoryService");

var _categories = require("@insided/shared/utils/categories");

var _common = require("@insided/shared/utils/common");

var _Bug = _interopRequireDefault(require("@insided/shared/icons/Bug"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'forum-content-curation-wrapper';
exports.cssAnchorName = cssAnchorName;
var PAGE_SIZE = 25;

var TopicList = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TopicList, _Component);

  var _super = _createSuper(TopicList);

  function TopicList() {
    var _this;

    (0, _classCallCheck2.default)(this, TopicList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "orderTopics", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      collapsed: false,
      isOverflowVisible: false,
      data: [],
      page: 1,
      loading: false,
      hasMore: true,
      title: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var forumId, _orderTopics$result$t, orderTopics;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              forumId = _this.props.forumId;

              if (!_this.props.isKnowledgeBase) {
                _context.next = 6;
                break;
              }

              _context.next = 4;
              return (0, _categoryService.getListReadableCategoryOrderTopics)(_this.props.forumId);

            case 4:
              orderTopics = _context.sent;
              _this.orderTopics = (_orderTopics$result$t = orderTopics === null || orderTopics === void 0 ? void 0 : orderTopics.result.topics[forumId]) !== null && _orderTopics$result$t !== void 0 ? _orderTopics$result$t : [];

            case 6:
              _context.next = 8;
              return _this.fetchData();

            case 8:
              window.addEventListener('scroll', _this.handleScroll);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchData", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var _this$state, page, data, _this$props, forumId, isKnowledgeBase, fetchTopicsData;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$state = _this.state, page = _this$state.page, data = _this$state.data;
              _this$props = _this.props, forumId = _this$props.forumId, isKnowledgeBase = _this$props.isKnowledgeBase;
              fetchTopicsData = isKnowledgeBase ? _categoryService.getListReadableCategoryContent : _categoryService.getReadableCuratedContent;
              fetchTopicsData(forumId, isKnowledgeBase ? parseInt(_categories.MODULE.KNOWLEDGE_BASE) : parseInt(_categories.MODULE.COMMUNITY), {
                page: page,
                pageSize: PAGE_SIZE
              }).then(function (response) {
                var _response$result$titl, _response$result;

                var newData = response.result.topics;

                _this.setState({
                  data: isKnowledgeBase ? [].concat((0, _toConsumableArray2.default)(data), (0, _toConsumableArray2.default)(newData)) : newData,
                  title: (_response$result$titl = (_response$result = response.result) === null || _response$result === void 0 ? void 0 : _response$result.title) !== null && _response$result$titl !== void 0 ? _response$result$titl : null,
                  loading: false,
                  hasMore: newData.length === PAGE_SIZE,
                  page: page + 1
                });
              }).catch(function (error) {
                console.error('Error fetching data:', error);

                _this.setState({
                  loading: false
                });
              });

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleScroll", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var threshold, scrollPosition, documentHeight;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              // Add a small threshold (1px) to account for pixel rounding at different zoom levels
              threshold = 1;
              scrollPosition = window.scrollY + window.innerHeight;
              documentHeight = document.documentElement.scrollHeight;

              if (!(scrollPosition >= documentHeight - threshold)) {
                _context3.next = 7;
                break;
              }

              if (!(!_this.state.loading && _this.state.hasMore)) {
                _context3.next = 7;
                break;
              }

              _context3.next = 7;
              return _this.fetchData();

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleCollapseButton", function (collapsed) {
      var next = !collapsed;

      _this.setState({
        collapsed: next,
        isOverflowVisible: false
      });

      window.localStorage.setItem('collapsedSticky', JSON.stringify(next));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setOverflowVisible", function () {
      _this.setState({
        isOverflowVisible: true
      });
    });
    return _this;
  }

  (0, _createClass2.default)(TopicList, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          cdn = _this$props2.cdn,
          forumId = _this$props2.forumId,
          isKnowledgeBase = _this$props2.isKnowledgeBase;
      var _this$state2 = this.state,
          stateData = _this$state2.data,
          isOverflowVisible = _this$state2.isOverflowVisible,
          loading = _this$state2.loading,
          collapsed = _this$state2.collapsed,
          title = _this$state2.title;
      var topicsList = isKnowledgeBase ? [].concat((0, _toConsumableArray2.default)(this.orderTopics), (0, _toConsumableArray2.default)(stateData)) : stateData;

      var isBugContentTypeEnabled = _common.common.isModuleActive('bugContentType');

      if (topicsList.length === 0) {
        return null;
      }

      var topicType = {
        question: (0, _preact.h)(_Question.default, null),
        article: (0, _preact.h)(_Article.default, null),
        answer: (0, _preact.h)(_Answer.default, null),
        discussion: isBugContentTypeEnabled ? (0, _preact.h)(_Bug.default, null) : (0, _preact.h)(_Discussion.default, null),
        idea: (0, _preact.h)(_Idea.default, null),
        productUpdate: (0, _preact.h)(_ProductUpdate.default, {
          height: 24,
          width: 24
        })
      };
      var overflowVisibleClassName = isOverflowVisible ? 'topic-curation-destination__container--overflowVisible' : '';
      return (0, _preact.h)("section", {
        className: "topic-curation-destination__container ".concat(overflowVisibleClassName, " full-width")
      }, (0, _preact.h)("div", {
        className: "sitewidth"
      }, !isKnowledgeBase && (0, _preact.h)("div", null, (0, _preact.h)(_TopicListHeader.default, {
        onClick: function onClick() {
          return _this2.toggleCollapseButton(collapsed);
        },
        className: (0, _classnames.default)(isKnowledgeBase && 'topic-curation__header--knowledgeBase'),
        iconClassName: (0, _classnames.default)({
          'icon--caret-up': !collapsed,
          'icon--caret-down': collapsed
        }),
        title: title,
        topicCount: topicsList.length
      })), (0, _preact.h)("div", {
        onMouseEnter: this.setOverflowVisible,
        tabIndex: isKnowledgeBase ? -1 : 0,
        role: "button",
        onKeyDown: function onKeyDown(event) {
          if (event.key === 'Enter' || event.key === 'Space') {
            _this2.setOverflowVisible();
          }
        }
      }, (0, _preact.h)(_ContentCurationList.default, {
        className: (0, _classnames.default)({
          'topic-curation__list--collapsed': collapsed
        }),
        "aria-hidden": collapsed || undefined
      }, topicsList.map(function (item, idx) {
        var _item$featuredImageAl, _item$author, _item$author2;

        var isBugContentTypeEnabled = _common.common.isModuleActive('bugContentType');

        var isConversation = item.contentType === 'conversation';

        if (isConversation && isBugContentTypeEnabled) {
          item.icon = (0, _preact.h)(_Bug.default, null);
        } else {
          item.icon = topicType[isConversation ? 'discussion' : item.contentType];
        }

        return (0, _preact.h)(_ForumContentCurationItem.default, (0, _extends2.default)({
          key: idx
        }, item, {
          image: item === null || item === void 0 ? void 0 : item.featuredImage,
          imageAltText: (_item$featuredImageAl = item === null || item === void 0 ? void 0 : item.featuredImageAltText) !== null && _item$featuredImageAl !== void 0 ? _item$featuredImageAl : title,
          url: item.topicUrl.destination,
          cdn: cdn,
          idx: idx,
          categoryId: forumId,
          type: item.contentType === 'conversation' ? 'discussion' : item.contentType,
          author: _objectSpread(_objectSpread({}, item.author), {}, {
            name: (_item$author = item.author) === null || _item$author === void 0 ? void 0 : _item$author.username,
            id: (_item$author2 = item.author) === null || _item$author2 === void 0 ? void 0 : _item$author2.id
          })
        }));
      }), loading && (0, _preact.h)(_LoadingSpinner.LoadingSpinner, null)))));
    }
  }]);
  return TopicList;
}(_preact.Component);

exports.default = TopicList;